import * as React from "react";
import { Switch, Route, Redirect, match } from "react-router-dom";

import { AllowedComponents, useTenant } from "services/tenant-provider";

import CourseListMyView from "../views/course-list-my.view";
import CourseDetailsMyView from "../views/course-details-my.view";
import { useModuleState, actionTypes } from "../reducers/my-courses";
import MyLearningPlanListView from "../views/learning-plan-list-my.view";
import MyLearningPlanDetailsView from "../views/learning-plan-my-details.view";

type Props = {
  match: match;
};

const MyCoursesRouter: React.FC<Props> = ({ match }) => {
  const [, dispatch] = useModuleState();
  React.useEffect(
    () => () => {
      dispatch({ type: actionTypes.RESET_MY_COURSES_FILTERS });
    },
    [dispatch]
  );
  const tenant = useTenant();
  const isLearningPlans = tenant.isComponentAllowed(
    AllowedComponents.LearningPlanCreation
  );
  return (
    <Switch>
      <Route exact path={match.path} component={CourseListMyView} />
      {isLearningPlans && (
        <Route
          exact
          path={`${match.path}/my-learning-plan`}
          component={MyLearningPlanListView}
        />
      )}
      {isLearningPlans && (
        <Route
          path={`${match.path}/my-learning-plan/:learningPlanId`}
          component={MyLearningPlanDetailsView}
        />
      )}
      <Route path={`${match.path}/:courseId`} component={CourseDetailsMyView} />

      <Redirect to={match.path} />
    </Switch>
  );
};

export default MyCoursesRouter;
